const plans = {
  apiClient: null,
  path: '/admin/plans',

  setClient(apiClient) {
    this.apiClient = apiClient;
  },

  async updatePaymentActive(id) {
    try {
      const response = await this.apiClient.put(`${this.path}/payment-active/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async updateDeliveryActive(id) {
    try {
      const response = await this.apiClient.put(`${this.path}/delivery-active/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async updatePaymentDiscount(id, form) {
    try {
      const response = await this.apiClient.put(`${this.path}/payment-discount/${id}`, form);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default plans;
